import { Text } from "../../Components/atoms/Typography/Text/Text";
import { ActionButton } from "../../Components/molecules/ActionButton/ActionButton";

export const getColumns = (t, clickHandler) => {
  const formatPhoneNumber = (phoneNumber) => {
    // Format the phone number
    const formattedNumber = phoneNumber.replace(
      /(\d{2})(\d{4})(\d{4})/,
      "$1 $2 $3",
    );

    return formattedNumber;
    };

    let columndata = [
        {
          fieldtext: "Location ID",
          field: "LocID",
          width: "140",
          textAlign: "Left",
        },
        {
          fieldtext: "Location name",
          field: "ClinicName",
          width: "180",
          textAlign: "Left",
        },

        {
          fieldtext: "Province",
          field: "Province",
          width: "180",
          textAlign: "Left",
        },

        {
          fieldtext: "District",
          field: "District",
          width: "180",
          textAlign: "Left",
        },

        {
          fieldtext: "City",
          field: "City",
          width: "180",
          textAlign: "Left",
        },

        {
          fieldtext: "Phone no.",
          field: "phoneNumber",
          width: "150",
          textAlign: "Left",
          enableGroupByFormat: true,
          template: (props) => {
        return (
          <span>{`${props.phoneNumberDialCode} ${formatPhoneNumber(
            props.phoneNumber,
            )}`}</span>
          );
        },
        },
        {
          fieldtext: "Status",
          field: "isActive",
          width: "130",
          textAlign: "Left",
          template: (props) => {
            return (
              <Text text={props.isActive ? "Active" : "Inactive"} />
            );
          },
         
        },

        {
          fieldtext: "Actions",
          field: "actions",
          width: "88px",
          textAlign: "Left",
          allowSorting: false,
          headerTextAlign: "Left",
          key: 6,
          template: (props) => {
            return (
              <ActionButton
                clickHandler={(e) => clickHandler(e, props)}
                Options={[

                  {
                    id: 1,
                    element: (
                      <Text
                        text={t("View")}
                        color={"blue.primaryBlue"}
                      />
                    ),
                  },

                  {
                    id: 2,
                    element: (
                      <Text
                        text={t("Edit")}
                        color={"blue.primaryBlue"}
                      />
                    ),
                  },
                  {
                    id: 3,
                    isShow: props.isActive, 
                    element: (
                      <Text
                        text={t("Inactivate location")}
                        color={"blue.primaryBlue"}
                      />
                    ),
                  },
                  {
                    id: 4,
                    isShow: !props.isActive, 
                    element: (
                      <Text
                        text={t("Activate location")}
                        color={"blue.primaryBlue"}
                      />
                    ),
                  },
                ]}
              />
            );
          },
        },
      ];
      return columndata;
    };